"use client";

import React, { useEffect } from "react";

export default function AppLaunchWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    // Ensure zero splash block on web to maximize response speed and Core Web Vitals
    document.documentElement.classList.remove("app-splash-active");
  }, []);

  return <>{children}</>;
}
